import { I18nStrings } from './index';

export const en: I18nStrings = {
  cardTitle: (num: number, side: 'front' | 'back') =>
    `Card ${num} (${side === 'front' ? 'Front' : 'Back'} side)`,
  insertFlipCard: 'Insert flip card',
  frontSide: 'Front side',
  backSide: 'Back side',
  flipToBack: 'Flip to back',
  flipToFront: 'Flip to front',
  clickToFlip: 'Click to flip',
  addText: 'Add a text',
  addTextPlaceholder: 'Enter your text...',
  addImage: 'Add an image',
  insertImage: 'Insert an image',
  uploadFile: 'Upload file',
  urlPlaceholder: 'Enter image URL...',
  ok: 'OK',
  cancel: 'Cancel',
  copyCard: 'Copy card',
  deleteCard: 'Delete card',
  resetFace: 'Reset',
  dragHandle: 'Drag to reorder',
  or: 'or'
};
